<template>
    <div class="sidebar-notification-box">
        <icon :name="symbol" class="icon"/>
        0
    </div>
</template>

<script>
    export default {
        name: "SidebarNotificationBox",
        props: {
            symbol: String
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/global";
.icon {
    margin-left: 10px;
    margin-right: 10px;
}

    .sidebar-notification-box {
        display: flex;
        height: 30px;
        width: calc(100% - 8px);
        justify-content: center;
        align-items: center;
        color: lighten($openRed, 30);
        background-color: lighten($openRed, 5);
        margin: 2px 4px 2px 4px;
        border: 1px solid lighten($openRed, 3);
        outline: 1px solid lighten($openRed, 12);
        outline-offset: -2px;
    }

    .sidebar-notification-box:hover {
        background-color: $openRed;
    }


</style>